import { render } from "./App.vue?vue&type=template&id=0c15c8d4"
const script = {}
script.render = render

export default script